import m from '../../styles/marketing.module.css';
import styles from './Sections.module.css';

interface Props {
  eyebrow: string;
  title: string;
}

/** Eyebrow + statement headline — the restrained header every section but
 *  "why us" opens with. The kinetic chapter word is kept for that one band. */
const SectionHeader = ({ eyebrow, title }: Props) => (
  <header className={styles.header} data-reveal>
    <div className={m.eyebrowRule}>{eyebrow}</div>
    <h2 className={m.midHead}>{title}</h2>
  </header>
);

export default SectionHeader;
